import { render, staticRenderFns } from "./btmNav.vue?vue&type=template&id=6cfffa98&scoped=true"
import script from "./btmNav.vue?vue&type=script&lang=js"
export * from "./btmNav.vue?vue&type=script&lang=js"
import style0 from "./btmNav.vue?vue&type=style&index=0&id=6cfffa98&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfffa98",
  null
  
)

export default component.exports